import { useMutation } from "@tanstack/react-query";
import { api } from "../api";

export const REPORT_REASONS = [
  { value: "spam",          label: "Spam or advertisement" },
  { value: "inappropriate", label: "Inappropriate content" },
  { value: "misleading",    label: "Misleading information" },
  { value: "safety",        label: "Safety concern" },
  { value: "other",         label: "Other" },
] as const;

export type ReportReason = (typeof REPORT_REASONS)[number]["value"];

export function useReportEvent(slug: string) {
  return useMutation({
    mutationFn: ({ reason, description }: { reason: ReportReason; description?: string }) =>
      api.post(`/events/public/${slug}/report`, { reason, description }),
  });
}
